import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {cardBodyStyles, cardStyles, imgStyles} from "../styles/ProductCard.css";

class ProductCard extends Component {
    constructor(props){
        super(props);

        this.state = {
          hovered: false,
          app: {},
          moved: false
        };
    }

    shiftY = () => {
      let id = this.state.app.name;
      let card = document.getElementById(id);
      if(!card) return;
      let moved = this.state.moved;
      let shiftValue  = (moved ? 5 : 0);
      card.style.bottom = shiftValue + 'px';
    };

    setHovered = (hovered) => {
      this.setState({hovered});
    };

    componentWillMount() {

    }

    componentDidMount() {
      this.setState({app: this.props.app});
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.app !== this.state.app) {
        this.setState({app: nextProps.app});
      }
    }

    componentWillUpdate(nextProps, nextState) {

    }

    componentDidUpdate(prevProps, prevState) {
      if(prevState.moved !== this.state.moved) {
        this.shiftY();
      }
    }

    render(){
        if(this.state.app && this.state.app.name) {
          return(
            <div className={"col-xl-2 col-md-3 col-6 mb-5"} onMouseOver={() => this.setHovered(true)} onMouseLeave={() => this.setHovered(false)}>
              <div className={"card card-secondary-outline text-center"} style={cardStyles(this.state.hovered)}
                   onClick={this.props.action} id={this.state.app.name}>
                <div className={"card-body"} style={cardBodyStyles}>
                  <div>
                    <img src={this.state.app.imgSrc} style={imgStyles} alt=""/>
                  </div>
                  <p className={"card-text"}>{this.state.app.name}</p>
                </div>
              </div>
            </div>
          );
        }
        else return null;
    }
}

ProductCard.propTypes = {
  action: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,

};

export default ProductCard;
